
import { Vue } from "vue-class-component";

class Box extends Vue {}
export default Box;
